import React, { useEffect } from "react"
import Icon from "../../common/icon/icon.component"
import { ProposalOpenButtonProps } from "../../common/types/proposal"
import { useDispatch, useSelector } from "react-redux"
import { ProposalSelector } from "../../state/proposal/selectors"
import { ProposalAction } from "../../state/proposal/actions"

export const ProposalOpenButton = (props: ProposalOpenButtonProps) => {
    const publicLink = useSelector(ProposalSelector.getPublicLink)
    const apiStatus = useSelector(ProposalSelector.getApiStatus)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!apiStatus.isLoaded && !apiStatus.isLoading) {
            dispatch(ProposalAction.fetch(props.hash))
        }
    }, [])

    const handleClick = (e) => {
        if (!publicLink) {
            e.preventDefault()
        }
    }

    return (
        <a className={"btn btn-outline-primary btn-sm mr-2"} href={publicLink}
            onClick={handleClick}
            target={"_blank"} rel={"noreferrer"}>
            <Icon value={"external-link-alt"} className={"mr-1"}/>
            {props.btnText}
        </a>
    )
}


// WEBPACK FOOTER //
// ./src/proposal/components/ProposalOpenButton.tsx